import * as React from 'react';
import './footer.css'

// export interface IFooterProps {
// }

export default class IFooter extends React.PureComponent<{}, any> {
  public render() {
    return (
      <div>
        {/* <div className="footer-container"> */}
          <div className="footer">
            <p className="font">KyleTallis Web Designs</p>
          </div>
        {/* </div> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/bundles/common/components/footer/footer.tsx